import { useAtomValue } from 'jotai';

import { hasActiveFilterAtom } from 'atoms/filters/sim';

export const useHasActiveFilters = () => {
  return useAtomValue(hasActiveFilterAtom);
};
